<unity-page-container
  [contentHeader]="$contentHeader()"
  [contentHeaderSecondary]="$contentHeaderSecondary()"
  [isLoading]="$resourceLoading()">
  <ng-container page-return> <unity-action-shared [action]="$returnToAgreementAction()" /></ng-container>
  <ng-container notifications />

  <ng-container actions>
    <unity-workflow-selector-shared
      [transitions]="$availableTransitions()"
      [disabled]="$workflowActionsDisabled()"
      (workflowEvent)="onWorkflow($event)" />
    <unity-action-delete-shared
      *unityAuthorize="deleteEntitlement"
      [disabled]="$workflowActionsDisabled()"
      [buttonText]="`Delete ${resourceName}`"
      [confirmationTitle]="`Confirm Delete ${resourceName}?`"
      [confirmationMessage]="`Are you sure you want to delete this ${resourceName}?`"
      (deleteEvent)="onDelete()" />
    <unity-button-download-shared
      actions
      buttonText="Download Reference File"
      [disabled]="$workflowActionsDisabled()"
      (clickEvent)="downloadFile()" />
  </ng-container>

  @let referenceFileView = $resource();
  @let formGroup = $formGroup();
  <unity-panel-manage-shared
    [resource]="$resource()"
    [resourceName]="resourceName"
    [formGroup]="formGroup"
    [isEditable]="$isEntitledToEdit()"
    [submitLoading]="$updateLoading()"
    (saveEvent)="onSave()"
    (detailEditEvent)="toggleWorkflowActions($event)">
    <unity-form-layout>
      <unity-textbox-readonly-control displayName="Agreement" [value]="referenceFileView?.agreement?.name!" />
      <unity-textbox-control displayName="Name" description="Provide the reference file name." [control]="formGroup.controls.name" />
    </unity-form-layout>
  </unity-panel-manage-shared>
</unity-page-container>
